module.exports = __webpack_public_path__ + "img/package.cf2077ee.svg";